<template>
  <div class="def-data-card" :class="{ 'def-data-card--no-label': hideLabel }">
    <div v-if="!hideLabel" class="def-data-card__label">{{ label || 'Label' }}</div>
    <div class="card-body card-flow-grid">
      <slot name="left"></slot>
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script setup>
defineProps({
  label: String,
  /** 与外层 Tab 标题复用时隐藏卡片内标题 */
  hideLabel: {
    type: Boolean,
    default: false
  }
})
</script>

<style scoped lang="scss">
.def-data-card {
  border: none;
  background-color: rgba(246, 251, 255, 1);
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  min-width: 0;
}

.def-data-card--no-label .card-body {
  border-radius: 8px;
  padding-top: 8px;
}

.def-data-card__label {
  padding: 16px;
  font-family: 'HarmonyOS Sans SC', sans-serif;
  font-size: 16px;
  color: #2E2E2E;;
  background-color: rgba(239, 244, 251, 0.70);
  border-radius: 4px;
}

.card-body {
  padding: 4px 8px 12px;
  min-width: 0;
}

/* 遥测/遥信项按可用宽度自动分列流式排布，避免固定高度内滚动 */
.card-flow-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 240px), 1fr));
  column-gap: 12px;
  row-gap: 0;
  align-content: start;

  :deep(.def-data-item) {
    min-width: 0;
  }
}
</style>
